module.exports = __webpack_public_path__ + "static/covid19M@2x-e6ec6ccbf4346ebf6df4fa0659312dcf.png";